import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2391bfe6")

_pushScopeId("data-v-2391bfe6")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (!_ctx.diffOnePrice(_ctx.total, _ctx.coupon, _ctx.before))
    ? (_openBlock(), _createBlock("label", _hoisted_1, " (" + _toDisplayString(_ctx.$wordList.ProperAllTextOnePrice.format(_ctx.before)) + ") ", 1))
    : _createCommentVNode("", true)
})